<template>
  <div class="monitoring-view p-4">
    <div v-if="loading" class="flex justify-center items-center h-64">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
    </div>

    <div v-else>
      <h1 class="text-xl font-semibold mb-4">Fixture Monitoring</h1>
      <!-- Add your monitoring content here -->
      <pre>{{ monitoringData }}</pre>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const loading = ref(true)
const monitoringData = ref(null)

const fetchMonitoringData = async () => {
  loading.value = true
  try {
    // Replace with your actual API call
    const response = await fetch(`/api/fixtures/${route.params.id}/monitoring`)
    monitoringData.value = await response.json()
  } catch (error) {
    console.error('Error fetching monitoring data:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchMonitoringData()
})

// Clean up if needed
onUnmounted(() => {
  // Clean up code here
})
</script>

<style scoped>
.monitoring-view {
  @apply bg-white rounded-lg shadow;
}
</style> 